module.exports = __webpack_public_path__ + "static/media/assistance_type_fuel.1f554ee6.svg";